import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["direction", "possibleDirections", "onChangeDirection"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { tooltipPropDirection } from "./types";

// Смапиваем значения, так как то что было зашито в поповер по названиям не подходит для тултипа + имеются лишние значения
var convertDirectionMap = {
  downLeft: 'downStartLeft',
  downRight: 'downStartRight',
  upLeft: 'upStartLeft',
  upRight: 'upStartRight',
  leftUp: 'leftStartUp',
  leftDown: 'leftStartDown',
  rightUp: 'rightStartUp',
  rightDown: 'rightStartDown'
};

// Преобразуем принятую в тултип позицию понятной для поповера
export var convertTooltipDirection = function convertTooltipDirection(direction) {
  return convertDirectionMap[direction] || direction;
};
export var convertPopoverDirection = function convertPopoverDirection(direction) {
  return Object.keys(convertDirectionMap).find(function (key) {
    return convertDirectionMap[key] === direction;
  }) || direction;
};
export var dataConverter = function dataConverter(_ref) {
  var _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'upCenter' : _ref$direction,
    _ref$possibleDirectio = _ref.possibleDirections,
    possibleDirections = _ref$possibleDirectio === void 0 ? tooltipPropDirection : _ref$possibleDirectio,
    _onChangeDirection = _ref.onChangeDirection,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread(_objectSpread({}, props), {}, {
    originalDirection: direction,
    direction: convertTooltipDirection(direction),
    possibleDirections: possibleDirections.map(convertTooltipDirection),
    onChangeDirection: function onChangeDirection(dir) {
      return _onChangeDirection === null || _onChangeDirection === void 0 ? void 0 : _onChangeDirection(convertPopoverDirection(dir));
    }
  });
};

// Разбиваем выбранную позицию на составляющие (upCenter => ['up', 'center'])
export var splitDirection = function splitDirection(direction) {
  return direction.split(/(?=[A-Z])/).map(function (s) {
    return s.toLowerCase();
  });
};
var getAlign = function getAlign(str) {
  return str === 'left' || str === 'right' ? 'horizontal' : 'vertical';
};

// Вычисляем отступ тултипа от компонента якоря, к которому он привязан
export var getOffset = function getOffset(direction, anchorSize) {
  var words = splitDirection(direction);
  var align = getAlign(words[0]);
  var comparableAnchorSize = align === 'vertical' ? anchorSize.width : anchorSize.height;
  var arrowSize = 28;
  var arrowOffset = align === 'vertical' ? 20 : 10;
  var tooltipOffset = comparableAnchorSize && comparableAnchorSize / 2 < arrowSize / 2 + arrowOffset && words[1] !== 'center' ? comparableAnchorSize / 2 - arrowOffset - arrowSize / 2 : 0;
  return {
    offsetVertical: align === 'vertical' ? 12 : tooltipOffset,
    offsetHorizontal: align === 'vertical' ? tooltipOffset : 17
  };
};
var positionsMap = {
  up: 'top',
  down: 'bottom',
  left: 'left',
  right: 'right'
};
var oppositeMap = {
  down: 'up',
  up: 'down',
  left: 'right',
  right: 'left'
};

// Функция определения позиции стрелочки тултипа
export var getTooltipArrowPosition = function getTooltipArrowPosition(direction) {
  var words = splitDirection(direction);
  var align = getAlign(words[0]);
  var styles = {
    width: align === 'horizontal' ? 12 : 28,
    height: align === 'horizontal' ? 28 : 12
  };
  styles[positionsMap[oppositeMap[words[0]]]] = 'var(--space-negative-200)';
  if (words[1] === 'center') {
    styles[align === 'horizontal' ? 'top' : 'left'] = '50%';
    styles.transform = "translate".concat(align === 'horizontal' ? 'Y' : 'X', "(-50%)");
    return styles;
  }
  if (getAlign(words[1]) === 'horizontal') {
    styles[words[1]] = 'var(--space-500)';
    return styles;
  }
  styles[positionsMap[words[1]]] = 'var(--space-250)';
  return styles;
};
var ease = [0.2, 0, 0, 1];
export var variants = {
  initial: {
    scale: 0.9,
    opacity: 0
  },
  animate: {
    scale: 1,
    opacity: 1,
    transition: {
      scale: {
        duration: 0.3,
        ease: ease
      },
      opacity: {
        duration: 0.15,
        ease: ease
      }
    }
  },
  exit: {
    scale: 0.9,
    opacity: 0,
    transition: {
      scale: {
        duration: 0.2,
        ease: ease
      },
      opacity: {
        duration: 0.1,
        ease: ease
      }
    }
  }
};